import { inject, Injectable } from '@angular/core';
import { FileMeta } from '@apis/cas/generated';
import { AudioService } from '@core/audio/audio.service';
import { LpAudioConfiguration } from '@typings/lp/generated';

@Injectable({
  providedIn: 'root',
})
export class LpAudioService {
  readonly #audioService = inject(AudioService);

  public async play(audio: FileMeta, wait: boolean, config: LpAudioConfiguration): Promise<void> {
    const url = audio.url;
    if (!url) {
      throw new Error(`Audio file '${audio.uid}' not found`);
    }
    const delayMs = (config.delay ?? 0) * 1000;
    const volume = config.volume;
    const loop = config.loop;
    if (loop) {
      const loopId = this.#audioService.loop(url, { volume }, delayMs);
    } else {
      if (delayMs > 0) {
        await new Promise((res) => setTimeout(res, delayMs));
      }
      const audio = this.#audioService.play(url, { volume });
      if (wait) await audio.waitForEnd();
    }
  }
}
